import {createReducer, on} from '@ngrx/store';
import {HttpLoadingActions} from './http-loading.actions';

export interface HttpLoadingState {
  activeRequestCount: number;
}

export const INITIAL_HTTP_LOADING_STATE: HttpLoadingState = {
  activeRequestCount: 0
};

export const httpLoadingState = createReducer(
  INITIAL_HTTP_LOADING_STATE,

  on(HttpLoadingActions.requestStarting, (state) => ({
    activeRequestCount: state.activeRequestCount + 1
  })),

  on(HttpLoadingActions.requestComplete, (state) => ({
    activeRequestCount: Math.max(0, state.activeRequestCount - 1)
  }))
);
